<script>
  import { onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
  import { gsap } from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger";
  import Footer from "@/components/Footer.vue";

  export default {
    name: "AppAbout",
    components: {Footer},
    methods: {
      handleEscapeKey(event) {
        if (event.key === "Escape") {
          this.$router.push('/'); // Redirection vers la page d'accueil
        }
      }
    },
    setup(props, { expose }) {

      const vm = getCurrentInstance().proxy;

      onMounted(() => {

        window.addEventListener('keydown', vm.handleEscapeKey);
        gsap.registerPlugin(ScrollTrigger);

        // Sélectionne les éléments dans l'ordre
        const allClips = document.querySelectorAll("[class^='clip-']");

        // Regrouper les éléments par leur classe (évite les doublons dans l'ordre d'animation)
        const uniqueClasses = [...new Set([...allClips].map(el => el.className))];

        // Boucle créant les délais entre les apparitions d'animations
        uniqueClasses.forEach((className, index) => {
          const elements = document.querySelectorAll(`.${className}`); // Sélectionne tous les éléments de cette classe

          if (className !== "clip-img"){
            gsap.fromTo(elements,
                { clipPath: "inset(0 100% 0 0)"},
                {
                  clipPath: "inset(0 0% 0 0)",
                  duration: 1,
                  ease: "power2.out",
                  delay: index * 0.15,
                }
            );
          }else{
            gsap.fromTo(elements,
                { clipPath: "polygon(0% 50%, 0% 0%, 0% 100%, 50% 100%)" },
                {
                  clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                  duration: 1,
                  ease: "power3.out",
                }
            );
          }
        });

        document.querySelectorAll(".clipL").forEach((e) => {
          gsap.fromTo(e,
              {clipPath: "inset(0 100% 0 0)"},
              {
                clipPath: "inset(0 0% 0 0)",
                scrollTrigger: {
                  trigger: e,
                  start: "top bottom",
                  end: "bottom bottom",
                  scrub: true,
                }
              }
          )
        });

        gsap.fromTo(".clipR",
            { clipPath: "inset(0 0 0 100%)" },
            {
              clipPath: "inset(0 0 0 0%)",
              scrollTrigger: {
                trigger: ".clipR",
                start: "top bottom",
                end: "bottom bottom",
                scrub: true,
              }
            }
        );
      });
      onBeforeUnmount(() => {
        window.removeEventListener('keydown', vm.handleEscapeKey);
      });

      // expose is optional if you need access from parent
      expose();
    }
  }
</script>

<template>
  <div class="about">
    <nav>
      <div class="back-btn">
        <router-link to="/"><img src="@/assets/images/icon/back.svg" alt="back-btn"></router-link>
      </div>
    </nav>
    <div class="aboutHeader">
      <img class="clip-img" src="@/assets/images/numa2.jpg" alt="">
      <div class="right">
        <h1 class="clip-1">Numa VERPILLON - 21 ans</h1>
        <p class="clip-2">Passionné de programmation depuis le collège, j'ai décidé de suivre cette voie afin d'en faire mon métier.
          Après avoir réalisé plusieurs petits projets (comme un bot discord), j'ai intégré l'IUT de Valence au sein d'un BUT Informatique.
          J'y ai alors appris les bases dans a peu près tous les domaines relatifs à l'informatique puisque cette formation est très polyvalente.
          </p>
        <p class="clip-3">Au bout de 2 années de BUT, j'ai décidé de faire une année de césure, et j'en ai profité pour créer mon entreprise.
          Ne voulant perdre cette année, je me suis mis à réaliser plusieurs projet notamment des missions freelance en auto-entrepreariat.
          La passion ainsi que la détermination, me pousse à donner le meilleur de moi même dans chacun de mes projets.
        </p>
      </div>
    </div>
    <section id="xp">
      <div class="etudes">
        <h4 class="clip-4">Études :</h4>
        <div>
          <p class="clip-5">BUT Information (2/3 ans complété)</p>
        </div>
      </div>
      <div class="cv">
        <h4 class="clip-5">Mon CV :</h4>
        <div>
          <p class="clip-6"><a href="@/assets/pdf/CV-NumaVerpillon-Info.pdf" download>CV - Informatique (Téléchargement)</a></p>
        </div>
      </div>
    </section>
    <div class="passions">
      <h1 class="clipL">MES PASSIONS</h1>
      <div class="passions-list">
        <div class="passion clipL musicBG">Musique</div>
        <div class="passion clipL catBG">Chats</div>
        <div class="passion clipL cinemaBG">Cinéma</div>
        <div class="passion clipR drawingBG">Dessin</div>
        <div class="passion clipR mangaBG">Mangas/Animes</div>
        <div class="passion clipR gamesBG">Jeux vidéos</div>
      </div>
    </div>
  </div>
  <Footer />

</template>

<style>
  .about{
    background: rgba(115, 0, 255, 0.18);
    color: white;
  }

  .back-btn{
    position: fixed;
    top: 0;
    left: 5px;
    width: 6vh;
    height: 6vh;
  }

  .back-btn img{
    width: 100%;
  }

  .aboutHeader {
    display: flex;
    justify-content: space-between;
    gap: 2vw;
    margin: 0 8vw 2vh 8vw;
    padding-top: 5vh;
  }

  .aboutHeader img {
    width: 25vw;
    height: 25vw;
  }

 .right{
   text-align: center;
 }

  .right h1{
    font-size: 3.6vw;
    margin: 0;
    margin-top: 2vh;
  }

  .right p{
    font-size: 1.3vw;
    margin: 2.8vh;
  }

  #xp{
    display: flex;
    justify-content: space-between;
    margin: 0 12vw;
  }

  #xp div{
    width: 34vw;
    margin: 5vh 0;
  }

  #xp h4{
    font-size: 3vw;
    margin: 0;
    margin-top: 2vh;
  }

  #xp p{
    font-size: 2vw;
    margin-top: 2vh;
  }

  .passions{
    margin-top: 15vh;
    padding-bottom: 15vh;
  }

  .passions h1{
    font-size: 4vw;
  }

  .passions-list{
    display: flex;
    justify-content: space-evenly;
    margin-left: 5%;
    margin-right: 5%;
  }

  .passion{
    position: relative;
    width: 16%;
    aspect-ratio: 1/1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-size: 1.6vw;
    font-weight: 400;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 1;
  }

  .passion::before{
    content: "";
    border-radius: 8px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: -1;
  }

  .musicBG{background-image: url("@/assets/images/californication.jpg");}
  .catBG{background-image: url("@/assets/images/awesome.jpg");}
  .cinemaBG{background-image: url("@/assets/images/se7en.jpg");}
  .drawingBG{background-image: url("@/assets/images/draw.jpg");}
  .mangaBG{background-image: url("@/assets/images/csm.jpg");}
  .gamesBG{background-image: url("@/assets/images/outer-wilds.jpg");}

  /*ANIMATIONS SCROLLTRIGGER*/
  .clipL, .clipR{
    position: relative;
    overflow: hidden;
    transition: clip-path 0.75s ease-out;
  }

  /* RESPONSIVE */
  @media (max-width: 480px) {
    .aboutHeader {
      flex-direction: column;
      align-items: center;
      margin: 5vh 4vw 2vh 4vw;
    }

    .aboutHeader img {
      width: 50vw;
      height: 50vw;
    }

    .right h1 {
      font-size: 5vw;
    }

    .right p {
      font-size: 3vw;
    }

    #xp{
      margin: 0 8vw;
    }

    #xp h4 {
      font-size: 5vw;
    }

    #xp p {
      font-size:  3.2vw;
    }

    .passions {
      margin-top: 2vh;
      margin-bottom: 12vh;
    }

    .passions h1 {
      font-size: 6vw;
    }

    .passions-list{
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    }

    .passion{
      width: 80%;
      margin: 15%;
      font-size: 3.6vw;
    }

    .mangaBG{
      font-size: 2.8vw;
    }
  }
</style>